import { pawnshop_reports_reader_service_v3 } from "../../../api/restclient";

import moment from "moment";

export const makeRequest = async (endpoint, params, method = "get") => {
  const response =
    method === "get"
      ? await pawnshop_reports_reader_service_v3.get(endpoint, params)
      : await pawnshop_reports_reader_service_v3.post(endpoint, params);
  return response;
};

export const constructUrlParams = (data) => {
  const urlParams = new URLSearchParams();
  urlParams.append("from", data.dates.from);
  urlParams.append("to", data.dates.to);
  return urlParams;
};

export const formatDateParam = (date) => moment(date).format("YYYY-MM-DD");
